import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiApplication, ApiCommission, ApiRegion, ApiSpecialities } from 'src/http';
import { Commission } from '../../commissions';
import { Page } from '../../page';
import BasicTable, { Application } from './BasicTable';
export interface Speciality extends Commission {
  commission: string;
}

export interface Region extends Commission {
  code: number | string;
}

export const ApplicationsUser: ComponentType = () => {
  const { t } = useTranslation();

  const [regions, setRegions] = useState<Region[] | null>(null);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);

  const getRegions = async () => {
    let params = {
      skip: 0,
      take: 100,
    };
    try {
      const data = await ApiRegion.fetchAll(params);
      setRegions(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [specialities, setSpecialities] = useState<Speciality[] | null>(null);
  const getSpecialities = async () => {
    let params = {
      skip: 0,
      take: 999,
      order: '-id',
    };
    try {
      const data = await ApiSpecialities.fetchAll(params);
      setSpecialities(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [commissions, setCommissions] = useState<Commission[] | null>(null);
  const getCommissions = async () => {
    let params = {
      skip: 0,
      take: 999,
      order: '-id',
    };
    try {
      const data = await ApiCommission.fetchAll(params);
      setCommissions(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [applications, setApplications] = useState<Application[] | null>(null);
  const getApplications = async () => {
    let params = {
      skip: page ? (page - 1) * 10 : 0,
      take: 10,
    };
    try {
      const data = await ApiApplication.fetchAll(params);
      setApplications(data.hits);
      setTotal(Math.ceil(data.total / 10));
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const createItem = async (item: Application) => {
    // DON'T DELETE IMPORTANT!!!
    // const formData = new FormData();
    // for (let index = 0; index < Object.keys(item).length; index++) {
    //   const element = Object.keys(item)[index];
    //   const value = item[element as keyof Application];
    //   if (typeof value === 'object' && value !== null) {
    //     formData.append(element, value as File);
    //   }
    //   if (typeof value === 'string') {
    //     formData.append(element, value);
    //   }
    //   if (typeof value === 'number') {
    //     formData.append(element, value.toString());
    //   }
    // }
    try {
      await ApiApplication.upload(item);
      await getApplications();
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const updateItem = async (item: Application) => {
    // DON'T DELETE IMPORTANT!!!
    // const formData = new FormData();
    // for (let index = 0; index < Object.keys(item).length; index++) {
    //   const element = Object.keys(item)[index];
    //   const value = item[element as keyof Application];
    //   if (typeof value === 'object' && value !== null) {
    //     formData.append(element, value as File);
    //   }
    //   if (typeof value === 'string') {
    //     formData.append(element, value);
    //   }
    //   if (typeof value === 'number') {
    //     formData.append(element, value.toString());
    //   }
    // }

    try {
      await ApiApplication.update(item.id || '', item);
      getApplications();
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  // const uploadCheck = async (props: any) => {
  //   await getApplications();
  //   const { file, expanded } = props;
  //   const formData = new FormData();
  //   formData.append('file', file as File);
  //   try {
  //     await ApiApplication.uploadCheck(expanded, formData);
  //   } catch ({ message }: any) {
  //     console.log(message);
  //   }
  // };

  useEffect(() => {
    getApplications();
    getSpecialities();
    getCommissions();
    getRegions();
  }, []);

  useEffect(() => {
    getApplications();
  }, [page]);

  const changePagination = (_page: number) => {
    setPage(_page);
  };

  return (
    <Page title={t('myApplications', 'Мои заявки')}>
      <BasicTable
        data={applications}
        createItem={createItem}
        updateItem={updateItem}
        commissions={commissions}
        regions={regions}
        specialities={specialities}
        changePagination={changePagination}
        total={total}
        uploadCheck={getApplications}
      />
    </Page>
  );
};
